import React from 'react';
import { AISuggestion } from '../../types';
import './AISuggestionsPanel.css';

interface AISuggestionsPanelProps {
  suggestions: AISuggestion[];
  reasoning: string;
  onUseSuggestion: (suggestion: AISuggestion) => void;
  onClose: () => void;
  loading?: boolean;
}

const TIPO_LABELS: Record<string, { label: string }> = {
  direta: { label: 'Direta' },
  acolhedora: { label: 'Acolhedora' },
  consultiva: { label: 'Consultiva' },
};

export const AISuggestionsPanel: React.FC<AISuggestionsPanelProps> = ({
  suggestions,
  reasoning,
  onUseSuggestion,
  onClose,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="ai-suggestions-panel">
        <div className="ai-suggestions-header">
          <span className="ai-suggestions-title">
            <span className="ai-icon">IA</span>
            Gerando sugestões para você enviar…
          </span>
          <button className="ai-suggestions-close" onClick={onClose} title="Fechar">
            ×
          </button>
        </div>
        <div className="ai-suggestions-loading">
          <div className="ai-loading-spinner"></div>
          <p>Analisando contexto e guidelines...</p>
        </div>
      </div>
    );
  }

  if (suggestions.length === 0) {
    return (
      <div className="ai-suggestions-panel">
        <div className="ai-suggestions-header">
          <span className="ai-suggestions-title">
            <span className="ai-icon">IA</span>
            Sugestões (rascunho)
          </span>
          <button className="ai-suggestions-close" onClick={onClose} title="Fechar">
            ×
          </button>
        </div>
        <div className="ai-suggestions-empty">
          <p>Não foi possível gerar sugestões no momento.</p>
          <p className="ai-suggestions-hint">Tente novamente ou verifique se a IA está habilitada nas configurações.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ai-suggestions-panel">
      <div className="ai-suggestions-header">
        <span className="ai-suggestions-title">
          <span className="ai-icon">IA</span>
          Sugestões (rascunho)
        </span>
        <button className="ai-suggestions-close" onClick={onClose} title="Fechar">
          ×
        </button>
      </div>
      <p className="ai-suggestions-scope-hint">
        Só preenchem a caixa de mensagem — não confundir com a IA autônoma do servidor.
      </p>

      <div className="ai-suggestions-list">
        {suggestions.map((suggestion) => {
          const tipoInfo = TIPO_LABELS[suggestion.tipo] || { label: suggestion.tipo };
          const confidencePercent = Math.round(suggestion.confianca * 100);

          return (
            <div key={suggestion.id} className={`ai-suggestion-card ai-suggestion-${suggestion.tipo}`}>
              <div className="ai-suggestion-card-header">
                <span className="ai-suggestion-tipo">
                  {tipoInfo.label}
                </span>
                <span className="ai-suggestion-confidence" title="Confiança">
                  {confidencePercent}%
                </span>
              </div>
              <div className="ai-suggestion-text">
                {suggestion.texto}
              </div>
              <div className="ai-suggestion-actions">
                <button
                  className="ai-suggestion-use-btn"
                  onClick={() => onUseSuggestion(suggestion)}
                >
                  Usar esta →
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {reasoning && (
        <div className="ai-suggestions-reasoning">
          <details>
            <summary>
              Como a IA chegou a essas sugestões
            </summary>
            <p>{reasoning}</p>
          </details>
        </div>
      )}
    </div>
  );
};
